:host {
  display: inline;
}
